export default "__VITE_ASSET__vCV0Om9j__"